import { useSelector } from "react-redux";

import IsMainContentContext from "../../../../context/IsMainContentContext";
import MediaEmbed from "../../../../components/MediaEmbed/component";

const LeadMediaVideoOrAudio = () => {
    const leadVideoOrAudio = useSelector(
        (state) => state.detail.leadVideoOrAudio
    );

    return (
        <span>
            <IsMainContentContext.Provider value={true}>
                <MediaEmbed {...leadVideoOrAudio} isLead={true} position={1} />
            </IsMainContentContext.Provider>
        </span>
    );
};

export default LeadMediaVideoOrAudio;
